import { useTheme } from "@emotion/react";
import { Button, Stack, Typography } from "@mui/material"
import CenteredText from "components/CenteredText"
import Page from "components/Page"

import BgPepper from "assets/images/pepper_back.png"
import { Link } from "react-router-dom";
import { useHistory } from 'react-router'
import { Box } from "@mui/system";

const GiocaPepper = () => {
    const history = useHistory();
    const theme = useTheme();


    return (<Page syncNavCommand="SCEGLI_PROSEGUO">
        <Stack spacing={1} sx={{
            display: 'flex',
            flex: 1
        }}>
            <div style={{ backgroundImage: `url(${BgPepper})`, height: '15rem', backgroundSize: 'cover' }}>

            </div>
            <Stack sx={{
                display: 'flex',
                flex: 1
            }}>
                <CenteredText>
                    <Button variant="contained" color="primary"
                        style={{ width: '100%' }} onClick={() => history.push('/pepper_selfie')}>
                        Posa SELFIE
                    </Button>
                </CenteredText>
                <CenteredText>
                    <Button variant="contained" color="primary"
                        style={{ width: '100%' }} onClick={() => history.push('/pepper_swag')}>
                        Posa SWAG
                    </Button>
                </CenteredText>
                <CenteredText>
                    <Button variant="contained" color="primary"
                        style={{ width: '100%' }} onClick={() => history.push('/pepper_balla')}>
                        Pepper, BALLA!
                    </Button>
                </CenteredText>
                <CenteredText>
                    <Button variant="contained" color="primary"
                        style={{ width: '100%' }} onClick={() => history.push('/pepper_esulta')}>
                        Pepper, ESULTA!
                    </Button>
                </CenteredText>

                <CenteredText>
                    <Link to="/scelta_iniziale">
                        <Typography variant="h6"
                            color={theme.palette.primary.main}
                            sx={{ textDecoration: 'underline' }}>
                            Torna alla Home Page
                        </Typography>
                    </Link>
                </CenteredText>
            </Stack>
        </Stack>
    </Page >)
}
export default GiocaPepper